import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateRepeatStatus } from 'repositories/BerthApi/updateRepeatStatus'
import { berthKeys } from 'repositories/queryKeys'

export function useUpdateRepeatStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateRepeatStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
    },
  })
}
